import React from 'react';
import CustomButton from '../ui/Button';
import { useTranslation } from "react-i18next";


const ContactSection = () => {
        const { t } = useTranslation("about"); // Hook to use translations
    
    return (
        <div className="relative mx-auto px-[30px] max-w-[1220px] md:h-[604px] ">
            <div className="bg-black h-full w-full rounded-lg shadow-lg text-center relative overflow-hidden">
                {/* Black Overlay */}
                {/* <div className="absolute inset-0 bg-black opacity-50 rounded-lg"></div> */}

                {/* Ellipse SVG */}
                <img
                    src="/assets/ellipse.svg"
                    alt="Ellipse Background"
                    className="absolute bottom-20  left-1/2 transform -translate-x-1/2 translate-y-1/2 z-5 opacity-100"
                />

                {/* Content */}
                <div className="relative z-10 flex flex-col justify-center items-center h-full ">
                    <div class="max-w-[818px] py-12 flex flex-col justify-center items-center text-center">
                        <div className='max-w-[631px]'>
                        <h2 className="web-heading-section text-color-3 mb-4 ">{t("join_team")}</h2>

                        </div>
                        <p className="body-large-30 text-color mt-3 mb-6">
                            {t("join_team_description")}
                        </p>
                        <CustomButton className='justify-center'>{t("send_resume")}</CustomButton>
                        <h2 className="title-xl-2 text-color-3 mb-4 mt-10">{t("spontaneous_applications")}</h2>
                        <p className="body-large-30 text-color mb-6 mt-4">
                            {t("spontaneous_applications_description")}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactSection;
